module.exports = __webpack_public_path__ + "static/580-44eedaae35988cf7ec44b0589a09c284.png";